import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { failureMessage } from '../Notifications/notificationsSlice';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import {
	getUser,
	getUserCompleted,
	getUserFailed,
	getUserSubscription,
	getUserSubscriptionCompleted,
	getUserSubscriptionFailed,
	registerUser,
	registerUserCompleted,
	registerUserFailed,
	updateUser,
	updateUserCompleted,
	updateUserFailed
} from './userSlice';

export const getUserEpic = (action$) =>
	action$.pipe(
		ofType(getUser.type),
		mergeMap(async () => {
			try {
				const user = await axios.get(`${primaryApi()}/api/v1/user`);

				return user.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => [getUserCompleted(res)]),
		catchError((error, source) =>
			merge(
				of(getUserFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export const getUserSubscriptionEpic = (action$) =>
	action$.pipe(
		ofType(getUserSubscription.type),
		mergeMap(async () => {
			try {
				const subscription = await axios.get(
					`${primaryApi()}/api/v1/user/subscription`
				);

				return subscription.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => [getUserSubscriptionCompleted(res)]),
		catchError((error, source) =>
			merge(
				of(
					getUserSubscriptionFailed(error.message),
					failureMessage(error.message)
				),
				source
			)
		)
	);

export const registerUserEpic = (action$) =>
	action$.pipe(
		ofType(registerUser.type),
		mergeMap(async (action) => {
			const payload = action.payload;

			const response = await axios.post(
				`${primaryApi()}/api/v1/registration/signup`,
				payload
			);

			if (response.status !== 200) {
				throw response.data;
			}

			return response.data;
		}),
		switchMap((res) => [registerUserCompleted(res)]),
		catchError((error, source) =>
			merge(
				of(registerUserFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export const updateUserEpic = (action$) =>
	action$.pipe(
		ofType(updateUser.type),
		mergeMap(async (action) => {
			const payload = action.payload;
			const formData = new FormData();

			if (payload.avatar) {
				formData.append('file', payload.avatar);
			}

			delete action.payload.avatar;

			for (const [key, value] of Object.entries(action.payload)) {
				formData.append(key, value);
			}

			const response = await axios.post(
				`${primaryApi()}/api/v1/user`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);

			if (response.status !== 200) {
				throw response.data;
			}

			return response.data;
		}),
		switchMap((res) => [updateUserCompleted(res), getUser()]),
		catchError((error, source) =>
			merge(
				of(updateUserFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export default [
	getUserEpic,
	getUserSubscriptionEpic,
	registerUserEpic,
	updateUserEpic
];
